import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';

export const SnackbarStyled = styled(Snackbar)(() => ({
  '& .MuiPaper-root': {
    height: 'auto',
  },
  marginTop: '25px',
}));
